import { render, staticRenderFns } from "./TotalLeitos.vue?vue&type=template&id=7915fd9c"
import script from "./TotalLeitos.vue?vue&type=script&lang=js"
export * from "./TotalLeitos.vue?vue&type=script&lang=js"
import style0 from "./TotalLeitos.vue?vue&type=style&index=0&id=7915fd9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports